/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileFeedbackPending = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V11h-2V9h-5V4H6v16h3v2H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M20 20.444h-4.758L13.102 22H11v-4.111h2v1.713l1.592-1.158H18V15h-4v-2h6zM12 16h-2v-2h2zm0-3h-2V9h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileFeedbackPending as FileFeedbackPending };
